import { ReactNode, lazy, Suspense } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { PageTransition } from "@/components/premium";
import InstallPromptBanner from "@/components/InstallPromptBanner";
import FloatingAdminButton from "@/components/FloatingAdminButton";
import AdminFeedbackFloatingButton from "@/components/admin/AdminFeedbackFloatingButton";
import "@/styles/sections.css";

const HelpWidget = lazy(() => import("@/components/HelpWidget"));

interface LayoutProps {
  children: ReactNode;
  hideFooter?: boolean;
  hideHelpWidget?: boolean;
  hideHeader?: boolean;
}

const Layout = ({ children, hideFooter, hideHelpWidget, hideHeader }: LayoutProps) => {

  return (
    <div className="flex min-h-screen flex-col">

      {!hideHeader && <Header />}
      {!hideHeader && <InstallPromptBanner variant="public" position="top" />}
      <main className="flex-1">
        <PageTransition>{children}</PageTransition>
      </main>
      {!hideFooter && <Footer />}
      {!hideHelpWidget && <Suspense fallback={null}><HelpWidget /></Suspense>}
      <FloatingAdminButton />
      <AdminFeedbackFloatingButton />
    </div>
  );
};

export default Layout;
